
// -----------Importar Componentes de Terceros------------------
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';

// -----------Importar Componentes Personalizados------------------
import BootstrapInput from '../../../components/Button_Bootstrap'


const StepMemoriaPrimero = ({ OnChange, FormActualizar }) => {
    const handleChangethelepone = (e) => {
        if (e.target.value.length < 11) {
            if (/^\d{0,10}$/.test(e.target.value)) { OnChange(e); }

        }

    }

    const handleChangeNombre = (e) => {
          if (/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜäÄëËïÏöÖ\s]*$/.test(e.target.value)) {
        OnChange(e);
    }
    }

       const handleChangeEmail = (e) => {
         if(/^[a-zA-Z0-9@.-_]*$/.test(e.target.value))
        {
            OnChange(e);
        }

    }
    return (
        <Box sx={{ flexGrow: 1, margin: '20px 0% 25px 0% !important' }}>
            <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 6, md: 12 }}
            >
                <Grid id='primer' item xs={12} sx={{ paddingTop: '0px !important', margin: '20px 0px 0px 0px !important' }}>
                    <FormControl fullWidth variant="standard">
                        <BootstrapInput required={true} onChange={handleChangeNombre} type='text' name='Nombre' placeholder='Nombre' value={FormActualizar.Nombre} id="bootstrap-input1" />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sx={{ paddingTop: '0px !important', margin: '15px 0px 0px 0px' }}>
                    <FormControl required={true} fullWidth variant="standard">
                        <BootstrapInput maxl onChange={handleChangethelepone} type='text' name='Telefono' placeholder='Teléfono' value={FormActualizar.Telefono} id="bootstrap-input2" />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sx={{ paddingTop: '0px !important', margin: '15px 0px 0px 0px' }}>
                    <FormControl fullWidth variant="standard">
                        <BootstrapInput required={true} onChange={handleChangeEmail} type='Email' name='Email' placeholder="Email" value={FormActualizar.Email} id="bootstrap-input3" />
                    </FormControl>
                </Grid>
            </Grid>
        </Box>
    );
}

export default StepMemoriaPrimero